import Landing from './Landing';

export default {
  name: 'Landing',
  path: '/',
  component: Landing,
};
